import { useAdminFetch } from '@/hooks/use-admin-fetch';
import {
  useApiMutationWithTransport,
  useApiQueryWithTransport,
  type ApiMutationOptions,
  type ApiQueryOptions,
  type ToRequest,
  type Transport,
} from '@/hooks/use-api-query';

export function useAdminApiQuery<T>(
  queryKey: readonly unknown[],
  path: string,
  options?: ApiQueryOptions<T>,
) {
  const transport = useAdminFetch() as Transport;
  return useApiQueryWithTransport<T>(queryKey, path, transport, options);
}

export function useAdminApiMutation<TData, TVars = void>(
  toRequest: ToRequest<TVars>,
  options?: ApiMutationOptions<TData, TVars>,
) {
  const transport = useAdminFetch() as Transport;
  return useApiMutationWithTransport<TData, TVars>(transport, toRequest, options);
}
